import { v4 as uuid } from 'uuid';

import { config } from 'app/config/config';
import { AppDispatch } from 'app/redux/types/types';
import { PkceUtils } from 'app/utils/pkce-utils';
import { persistor } from 'app/redux/store/store';

import { setAuthenticationKeysActionCreator } from './set-authentication-keys-action-creator';

export const authorizeActionCreator = () => (dispatch: AppDispatch) => {
    const authorizationUrl = config.AUTH_URL;
    const scope = config.AUTH_SCOPE;
    const clientId = config.AUTH_CLIENT_ID;
    const redirectUri = config.AUTH_CALLBACK_URL;
    const appLanguage = config.LANGUAGE;
    const authTheme = config.AUTH_THEME;
    const authenticationKey = uuid();
    const { codeChallenge, codeVerifier } = PkceUtils.generateCodeChallengeAndCodeVerifier();

    dispatch(setAuthenticationKeysActionCreator(codeVerifier, authenticationKey));

    const url = new URL(authorizationUrl);
    const params = url.searchParams;

    params.append('client_id', clientId);
    params.append('redirect_uri', redirectUri);
    params.append('response_type', 'code');
    params.append('scope', scope);
    params.append('state', authenticationKey);
    params.append('code_challenge_method', 'S256');
    params.append('code_challenge', codeChallenge);
    params.append('locale', appLanguage);
    params.append('theme', authTheme);

    persistor.flush().then(() => window.location.assign(url.toString()));
};
